import p from "./highrise1516.mjs";
import a from "./highrise1517.mjs";
import i from "./highrise1518.mjs";
import h from "./highrise1519.mjs";
import s from "./highrise1520.mjs";
function t(e) {
  var o = -1, l = e == null ? 0 : e.length;
  for (this.clear(); ++o < l; ) {
    var r = e[o];
    this.set(r[0], r[1]);
  }
}
t.prototype.clear = p;
t.prototype.delete = a;
t.prototype.get = i;
t.prototype.has = h;
t.prototype.set = s;
export {
  t as default
};
